'use strict';

const {trackClickEvent} = require('od-modules/track_events/track.frontevents.utils');
var baggagesManagerMixin = require('../../modules/mixins/baggages_manager.mixin');
var baggagesObserverMixin = require('../../modules/mixins/baggages_observer.mixin');
var trackingUtils = require('../../modules/utils/tracking.utils');
const {trackNag} = require('od-modules/track_events/catalog/nags');
var ancillariesTracking = require('../../tracking/ancillaries')('guarantees');
var boardingOptionsCollection = require('../../modules/collections/boarding_options/boarding_options.collection').getInstance();
var BAGS_REMOVE = 'baggages-remove';
var BAGS_NOSELECTION = 'baggages-noselection';
var BAGS_NOSELECTION_EXTRA = 'baggages-noselection-extra';
var BAGS_REMOVE_EXTRA = 'baggages-remove-extra';
var isExtraBaggage = false;
var dialogOptions = {};
var previousBaggageSelection;
const ancillariesTrackingSO = require('../../tracking/ancillaries')('serviceOptions');
const NAG_CONTAINERS = {
    CONTAINER_TEMPLATE: '.nag_template_container',
    CONTAINER_TEMPLATE_OFFER: '.nag_offer_template_container',
    CONTAINER_TEMPLATE_HOTEL: '.nag_hotel_template_container',
};

const NAGS_LOGIC_VARIATIONS = {
    CABIN_FIRST: 1,
    CHECKED_FIRST: 2,
    CHECKED_ONLY: 3,
    NO_NAGS: 4,
};

Odigeo.defineWidget('nagmanager', Odigeo.Widget.extend(baggagesObserverMixin.extend(baggagesManagerMixin.extend({
    modelClass: Odigeo.Model.extend({
        insurancesNoSelectionAlreadyShown: false,
        defaults: {
            primeUserBlockedNagAlreadyShown: false,
            cabinBagsContinueNagAlreadyShown: false,
            baggagesContinueNagAlreadyShown: false,
            baggagesRemoveNagAlreadyShown: false,
            baggagesExtendNagAlreadyShown: false,
            flexNagAlreadyShown: false,
            insurances: {},
            flex: null,
            isUserLoggedIn: false,
        },
        update: function() {
            var nagState = Odigeo.Utils.parseJson(Odigeo.Session.get('nagsState'));

            if (Odigeo._.isObject(nagState)) {
                Odigeo._.each(nagState, function(value, index) {
                    this.set(index, value);
                }, this);
            }
        },
        getSessionFormat: function() {
            return Odigeo._.pick(
                this.toJSON(),
                'baggagesContinueNagAlreadyShown',
                'baggagesRemoveNagAlreadyShown',
                'baggagesExtendNagAlreadyShown'
            );
        },
        disableInsurancesNoSelectionNag: function() {
            this.insurancesNoSelectionAlreadyShown = true;
        },
        seatsSelectionInfo: function() {
            var seatMap = this.get('seatmap-selection') || {};
            var seatMapActive = Odigeo._.get(seatMap, 'isEnabled', false);
            var seatType = seatMapActive ? 'seatmap-selection' : '';
            var noSeatsSelected;

            if (seatMapActive) {
                noSeatsSelected = Odigeo._.size(seatMap.priceData.seatMapSelectionRequests) === 0;
            } else {
                noSeatsSelected = true;
            }

            return {
                seatMapActive,
                seatsSelected: !noSeatsSelected,
                type: seatType,
                data: seatMap,
            };
        },
        noSeatsSelected: function() {
            const seatSelectionInfo = this.seatsSelectionInfo();
            const seatsEnabled = Odigeo._.get(seatSelectionInfo, 'seatMapActive', false);
            return seatsEnabled && !seatSelectionInfo.seatsSelected;
        },
        seatsNagShown() {
            const {data: {seatsContinueNagAlreadyShown = false, seatsRemoveNagAlreadyShown = false} = {}} = this.seatsSelectionInfo();
            return !seatsContinueNagAlreadyShown && !seatsRemoveNagAlreadyShown;
        },
    }),

    init: function() {
        this.options = Odigeo.Utils.parseOptions(this.options);
        this.bindEvents();
    },
    bindEvents: function() {
        this.suscribeBaggagesCollectionEvents();
    },
    onBaggageChange: function(data) {
        if (!data.avoidNags) {
            var currentOption = data.currentOption;
            var previousOption = data.previousOption;
            var isBaggageBeingRemoved = currentOption.get('selected') && currentOption.get('price') === 0 && previousOption.get('price') !== 0;
            var idPassenger = currentOption.get('idPassenger');

            if (!Odigeo._.isUndefined(idPassenger) && isBaggageBeingRemoved) {
                isExtraBaggage = this.getPassengerIncludedAndSelectableRows(idPassenger).length > 0;
            }

            this.shootOnChangedBaggagesNags({
                isBaggageBeingRemoved: isBaggageBeingRemoved,
                idPassenger: idPassenger,
                previousOption: data.previousOption,
                isUserAction: data.isUserAction,
            });
        } else {
            this.setBaggageExtendNagAlreadyShown();
        }
    },
    shootOnChangedBaggagesNags: function(options) {
        if (options.isBaggageBeingRemoved && this.shouldShowRemoveBaggagesNag()) {
            if (options.isUserAction && Odigeo._.isObject(options.previousOption)) {
                previousBaggageSelection = options.previousOption;
                this.showRemoveBaggagesNag();
            }
        } else if (this.shouldShowExtendBaggagesNag(options.idPassenger)) {
            Odigeo._.delay(Odigeo._.bind(this.showBaggagesExtendNag, this), 500, options.idPassenger);
        }
    },
    removedInsuranceSelected: function(options) {
        options.nagName = 'nag_insurance_removal';
        this.noInsuranceSelected(options);
    },
    noInsuranceSelected: function(options) {
        var insurancesWidgetId = this.model.get('insurances');
        var mustContinue = Odigeo._.isEmpty(insurancesWidgetId) || this.model.insurancesNoSelectionAlreadyShown;

        if (!mustContinue) {
            this.model.insurancesNoSelectionAlreadyShown = true;
            options.nagName = options.nagName || 'nag_insurance_submit';
            this.showNoInsuranceSelectedNag(options);
        }

        if (!options.doNotTriggerContinue) {
            Odigeo.trigger(this.id + ':insuranceMustContinue', mustContinue);
        }
    },

    checkNoInsuranceSelectionIfRejected: function(options) {
        var mustContinue = this.model.insurancesNoSelectionAlreadyShown;
        if (!mustContinue) {
            this.model.insurancesNoSelectionAlreadyShown = true;
            options.nagName = 'nag_insurance_submit';
            this.showNoInsuranceSelectedNag(options);
        } else {
            Odigeo.trigger(this.id + ':insurancesNagContinueWithoutChecking');
        }
    },

    showNoInsuranceSelectedNag: function(options) {
        var isAncillaryStepOpenFirstTime = Odigeo.Utils.parseJson(Odigeo.Session.get('insuranceNagAlreadyShown'));
        var getContinueButtonCallback = function(options) {
            switch (options.continuanceMode) {
                case 'DO_NOTHING':
                    return null;
                case 'SCROLL':
                    return Odigeo._.partial(function() {
                        Odigeo.trigger('nagmanager:insurancesNagScroll');
                    });
                case 'UNCHECK':
                    return Odigeo._.partial(function() {
                        Odigeo.trigger('nagmanager:uncheckProduct', options.insuranceId);
                    });
                default:
                    return Odigeo._.partial(function() {
                        Odigeo.trigger('nagmanager:insurancesNagContinue', options.checkRejectInsuranceOnContinue);
                    });
            }
        };
        var trackingPage = ancillariesTracking.getPageToTrack();

        if (Odigeo._.isNull(isAncillaryStepOpenFirstTime) && !options.shouldAvoidNag) {
            var nagName = options.nagName;
            this.showNag(
                this.options.nagTranslations.insurances.noInsuranceSelected,
                {
                    page: trackingPage,
                    trackingLoad: nagName + '_appearances',
                    trackingAdd: nagName + '_add',
                    trackingContinue: nagName + '_continue',
                },
                Odigeo._.bind(function() {
                    Odigeo.trigger(this.id + ':addInsurance', options.insuranceId);
                }, this),
                getContinueButtonCallback(options)
            );
            trackNag('NO_INSURANCE_SELECTED');
            Odigeo.Session.set('insuranceNagAlreadyShown', true);
        }
    },

    checkIfFlexNagShouldBeShown: function(widgetId, isFlexSelected) {
        var subScribedFlex = this.model.get('flex');
        var skipNag = Odigeo._.isUndefined(subScribedFlex) || subScribedFlex !== widgetId;
        var trackingPage = ancillariesTracking.getPageToTrack();
        if (!skipNag && !isFlexSelected && !this.model.get('flexNagAlreadyShown')) {
            this.showNag(
                this.options.nagTranslations.flex.noFlexSelected,
                {
                    page: trackingPage,
                    trackingLoad: 'nag_flexible_removal_appearances',
                    trackingAdd: 'nag_flexible_removal_add',
                    trackingContinue: 'nag_flexible_removal_continue',
                },
                Odigeo._.bind(function() {
                    Odigeo.trigger(this.id + ':addFlex');
                }, this));
            trackNag('FLEX_NAG');
            this.model.set('flexNagAlreadyShown', true);
        }
    },

    getDialogOptions: function(type, isExtraBaggage) {
        var extra = isExtraBaggage ? '_extra' : '';
        var nagBaggagePrefix = 'nag_baggage';
        var removeOrSubmit = '';

        switch (type) {
            case BAGS_REMOVE:
                dialogOptions.typeBaggage = isExtraBaggage ? BAGS_REMOVE_EXTRA : BAGS_REMOVE;
                removeOrSubmit = '_removal';
                break;
            case BAGS_NOSELECTION:
                dialogOptions.typeBaggage = isExtraBaggage ? BAGS_NOSELECTION_EXTRA : BAGS_NOSELECTION;
                removeOrSubmit = '_submit';
                break;
        }

        dialogOptions.trackingLoad = nagBaggagePrefix + extra + removeOrSubmit + '_appearances';
        dialogOptions.trackingAdd = nagBaggagePrefix + extra + removeOrSubmit + '_add';
        dialogOptions.trackingContinue = nagBaggagePrefix + extra + removeOrSubmit + '_continue';
    },

    /** CONTINUE NAG **/
    showDefaultBaggageContinueNag: function() {
        isExtraBaggage = this.getPassengerIncludedAndSelectableRows(0).length > 0;
        this.getDialogOptions(BAGS_NOSELECTION, isExtraBaggage);
        this.setBaggageContinueNagAlreadyShown();
        this.showNag(
            isExtraBaggage ?
                this.options.nagTranslations.baggages.noBagsExtraSelected :
                this.options.nagTranslations.baggages.noBagsSelected,
            dialogOptions,
            Odigeo._.bind(this.addBaggages, this),
            Odigeo._.bind(this.proceedToPayment, this),
            null,
            null,
            true
        );
        trackNag('DEFAULT_BAGGAGE');
    },
    addBaggages: function() {
        Odigeo.trigger(this.id + ':addBaggages');
    },
    evenUpBaggageSelection: function() {
        Odigeo.trigger(this.id + ':evenUpBaggageSelection');
    },
    addPrime: function() {
        Odigeo.trigger(this.id + ':addPrime');
    },
    proceedToPayment: function() {
        Odigeo.trigger(this.id + ':continue');
    },
    enableContinueButton: function() {
        Odigeo.trigger('passengers_manager:continueButtonBinding');
    },
    setCabinBagsContinueNagAlreadyShown: function() {
        this.model.set('cabinBagsContinueNagAlreadyShown', true);
    },
    setBaggageContinueNagAlreadyShown: function() {
        this.model.set('baggagesContinueNagAlreadyShown', true);
    },
    setPrimeUserBlockedNagAlreadyShown: function() {
        this.model.set('primeUserBlockedNagAlreadyShown', true);
    },
    setPrimeUserBlockedNagToShownAgain: function() {
        this.model.set('primeUserBlockedNagAlreadyShown', false);
    },
    setBaggageNagsToDisplayed: function() {
        this.setBaggageExtendNagAlreadyShown();
        this.setBaggageRemoveNagAlreadyShown();
        this.setBaggageContinueNagAlreadyShown();
    },
    updateBaggageNagAvailability: function() {
        if (this.isBaggagePropensityLowForNag()) {
            this.setBaggageNagsToDisplayed();
        }
    },
    shouldShowBaggageContinueNag: function() {
        return this.noNagHasBeenShown() &&
            this.isProductEnabled('baggage-selection') &&
            this.hasAnySelectableBaggage() &&
            this.hasNoBagBeenSelected();
    },
    isProductEnabled: function(productId) {
        const product = this.model.get(productId) || {};
        return Odigeo._.get(product, 'isEnabled', false);
    },
    shouldShowSeatsNag() {
        return this.model.noSeatsSelected() && this.model.seatsNagShown();
    },
    shouldShowPriorityBoardingNag: function() {
        const isAB = this.isNewCabinBagsNagLogicActive();

        return boardingOptionsCollection.mustShowNag()
            && (isAB ? !this.hasCabinBagsContinueNagBeenShown() : this.shouldShowBaggageContinueNag());
    },
    shouldShowSmartNagBaggage: function() {
        var numPassengersWithBaggage = this.options.numAdults + this.options.numChildren;

        return this.doBaggageAllowSmartNag() &&
            numPassengersWithBaggage <= 2 &&
            !boardingOptionsCollection.mustShowNag();
    },
    shouldShowEvenUpNag: function() {
        return this.doBaggageAllowEvenUpNag();
    },
    noNagHasBeenShown: function() {
        return !this.hasPrimeUserBlockedNagBeenShown() &&
            !this.hasContinueNagBeenShown() &&
            !this.hasRemoveNagBeenShown() &&
            !this.hasExtendNagBeenShown();
    },
    hasCabinBagsContinueNagBeenShown: function() {
        return this.model.get('cabinBagsContinueNagAlreadyShown');
    },
    hasContinueNagBeenShown: function() {
        return this.model.get('baggagesContinueNagAlreadyShown');
    },
    hasPrimeUserBlockedNagBeenShown: function() {
        return this.model.get('primeUserBlockedNagAlreadyShown');
    },

    /* EXTEND NAG */
    showBaggagesExtendNag: function(idPassenger) {
        const data = {};
        let discount;
        const discountPercentage = this.getBaggageBundleDiscountPercentage();
        const showNagOffer = discountPercentage > 0 && Odigeo.AB.isBaggageDiscountEnabled;
        let nagContainer = NAG_CONTAINERS.CONTAINER_TEMPLATE;
        let nagTranslations = this.options.nagTranslations.baggages.extendSelection;
        if (showNagOffer) {
            nagContainer = NAG_CONTAINERS.CONTAINER_TEMPLATE_OFFER;
            nagTranslations = this.options.nagTranslations.baggages.extendOfferSelection;
            discount = this.getDiscountedPart();
            data.totalDiscount = discount;
            data.discountPercentage = discountPercentage;
            data.formattedTotalDiscount = Odigeo.Utils.formatCurrency(discount);
        }
        if (!this.hasExtendNagBeenShown()) {
            this.setBaggageExtendNagAlreadyShown();

            this.showNag(
                nagTranslations,
                {
                    trackingLoad: 'nag_baggage_extend_appearances',
                    trackingAdd: 'nag_baggage_extend_add',
                    trackingContinue: 'nag_baggage_extend_continue',
                },
                Odigeo._.bind(this.extendBaggageSelection, this, idPassenger),
                null,
                nagContainer,
                data,
                undefined,
                {
                    blockScroll: false,
                },
            );
            trackNag('BAGGAGE_EXTEND');
        }
    },
    extendBaggageSelection: function(idPassenger) {
        var passengerCurrentSelection = this.getAllBaggagesOptions({
            idPassenger: idPassenger,
            isSelectableBaggage: true,
            selected: true,
        });

        Odigeo._.each(passengerCurrentSelection, function(selectableOption) {
            var newSelectionPattern = Odigeo._.pick(selectableOption.getAll(), 'idRow', 'pieces', 'kilos', 'price');
            this.updateAllMatchingBaggagesOptions(newSelectionPattern, idPassenger, {avoidNags: false});
        }, this);
    },
    setBaggageExtendNagAlreadyShown: function() {
        this.model.set('baggagesExtendNagAlreadyShown', true);
    },
    shouldShowExtendBaggagesNag: function(idPassenger) {
        if (this.options.numTravellers === 2 && this.options.numInfants === 1) {
            return false;
        } else {
            return this.options.numTravellers > 1 &&
                this.getBaggageSelectedPieces() !== 0 &&
                !this.hasExtendNagBeenShown() &&
                this.hasPassengerAllRowsSelected(idPassenger) &&
                this.isThereAnyPassengerToExtend(idPassenger);
        }
    },
    hasPassengerAllRowsSelected: function(idPassenger) {
        var selectablePiecesSelected = this.getAllBaggagesOptions({
            idPassenger: idPassenger,
            isSelectableBaggage: true,
            selected: true,
        });

        selectablePiecesSelected = Odigeo._.filter(selectablePiecesSelected, function(piece) {
            return piece.get('piecesToShow') > 0;
        });

        return !Odigeo._.isUndefined(this.getPassengerRows(idPassenger)) &&
            this.getPassengerSelectableRows(idPassenger).length === selectablePiecesSelected.length;
    },
    isThereAnyPassengerToExtend: function(idPassenger) {
        var orderedOptions = this.sortSelectedPiecesByPassengerAndSegment();

        var otherPassengerIds = Odigeo._.chain(orderedOptions).keys().filter(function(key) {
            return key.toString() !== idPassenger.toString();
        }).value();

        var currentPassengerOptions = orderedOptions[idPassenger];
        if (Odigeo._.isEmpty(otherPassengerIds)) {
            return true;
        }
        return !Odigeo._.every(otherPassengerIds, function(id) {
            return this.comparePassengerOptions(currentPassengerOptions, orderedOptions[id]);
        }, this);
    },
    getAllSelectedSelectablePieces: function() {
        var selectedSelectablePieces = this.getAllBaggagesOptions({
            isSelectableBaggage: true,
            selected: true,
        });

        return selectedSelectablePieces;
    },
    sortSelectedPiecesByPassengerAndSegment: function() {
        var selectedSelectablePieces = this.getAllSelectedSelectablePieces();
        var orderedOptions = {};
        var optionIdPassenger;

        Odigeo._.each(selectedSelectablePieces, function(option) {
            optionIdPassenger = option.get('idPassenger');

            orderedOptions[optionIdPassenger] = orderedOptions[optionIdPassenger] || {};

            if (option.get('piecesToShow') > 0) {
                orderedOptions[optionIdPassenger][option.get('idRow')] = option;
            }
        });

        return orderedOptions;
    },
    comparePassengerOptions: function(firstOptions, secondOptions) {
        return Odigeo._.every(firstOptions, function(option, key) {
            return secondOptions[key] &&
                Odigeo._.isEqual(this.getRawOptData(option), this.getRawOptData(secondOptions[key]));
        }, this);
    },
    getRawOptData: function(data) {
        return Odigeo._.pick(data ? data.attributes : {}, 'kilos', 'pieces', 'piecesToShow', 'price');
    },
    hasExtendNagBeenShown: function() {
        return this.model.get('baggagesExtendNagAlreadyShown');
    },

    /** REMOVE NAG **/
    showRemoveBaggagesNag: function() {
        this.setBaggageRemoveNagAlreadyShown();
        this.getDialogOptions(BAGS_REMOVE, isExtraBaggage);

        const translations = isExtraBaggage
            ? this.options.nagTranslations.baggages.removeBagsExtra
            : this.options.nagTranslations.baggages.removeBags;

        this.showNag(
            translations,
            dialogOptions,
            Odigeo._.bind(this.restoreSelection, this),
            undefined,
            undefined,
            undefined,
            undefined,
            {
                blockScroll: false,
            },
        );
        trackNag('REMOVED_BAGGAGE');
    },
    restoreSelection: function() {
        this.updateBaggageSelection({
            newOptionCid: previousBaggageSelection,
            isUserAction: false,
            triggerEvents: true,
        });
    },
    setBaggageRemoveNagAlreadyShown: function() {
        this.model.set('baggagesRemoveNagAlreadyShown', true);
    },
    shouldShowRemoveBaggagesNag: function() {
        return !this.hasRemoveNagBeenShown() && !this.hasContinueNagBeenShown();
    },
    hasRemoveNagBeenShown: function() {
        return this.model.get('baggagesRemoveNagAlreadyShown');
    },

    subscribeWidget: function(source) {
        var widget = this.model.get(source.widgetId) || {};
        widget[source.widgetId] = source.details || {};

        this.model.set(source.widgetId, widget[source.widgetId]);
    },
    showRemoveSeatsNags: function(callbacks) {
        var seats = this.model.get('seatmap-selection');
        var seatSelectionInfo = this.model.seatsSelectionInfo();
        var seatsSelected = seatSelectionInfo.seatsSelected;
        var seatMapNoSelection = !seatsSelected;
        var seatMapSelection = seatsSelected;
        var needsToBeShown = seatMapNoSelection ?
            !seats.seatsRemoveNagAlreadyShown && !seats.seatsContinueNagAlreadyShown :
            true;

        if (needsToBeShown) {
            if (seatMapSelection) {
                this.showNag(
                    this.options.nagTranslations.seats.remove,
                    {
                        trackingLoad: 'nag_seats_removal_appearances',
                        trackingAdd: 'nag_seats_removal_add',
                        trackingContinue: 'nag_seats_removal_continue',
                    },
                    callbacks.keepCallBack, callbacks.removeCallBack
                );
                trackNag('REMOVED_SEAT');
                seats.seatsRemoveNagAlreadyShown = true;
            } else if (seatMapNoSelection) {
                this.showNoSeatsSelectedNags(callbacks);
            }
        } else if (seatMapNoSelection) {
            callbacks.closeCallBack();
        }
    },
    showNoSeatsSelectedNags: function(callbacks) {
        var seats = this.model.get('seatmap-selection');
        var needsToBeShown = !seats.seatsRemoveNagAlreadyShown && !seats.seatsContinueNagAlreadyShown;
        if (needsToBeShown) {
            this.showNag(
                this.options.nagTranslations.seats.continues,
                {
                    trackingLoad: 'nag_seats_close_seatmap_appearances',
                    trackingAdd: 'nag_seats_close_seatmap_add',
                    trackingContinue: 'nag_seats_close_seatmap_continue',
                },
                null, callbacks.closeCallBack
            );
            trackNag('NO_SEATS_SELECTED');
            seats.seatsContinueNagAlreadyShown = true;
        } else {
            callbacks.closeCallBack();
        }
    },
    showContinueSeatsNags: function() {
        if (!this.model.get('seatmap-selection').seatsContinueNagAlreadyShown) {
            this.showNag(
                this.options.nagTranslations.seats.continues,
                {
                    trackingLoad: 'nag_seats_submit_appearances',
                    trackingAdd: 'nag_seats_submit_add',
                    trackingContinue: 'nag_seats_submit_continue',
                },
                Odigeo._.bind(function() {
                    Odigeo.trigger(this.id + ':goToSeats');
                }, this),
                Odigeo._.bind(this.proceedToPayment, this),
                null,
                null,
                true
            );
            trackNag('SEATS_ON_CONTINUE');
            this.model.get('seatmap-selection').seatsContinueNagAlreadyShown = true;
        }
    },
    notifyNagProductEnabled(type, hasProductEnabled) {
        const product = this.model.get(type) || {};

        if (Object.keys(product).length > 0) {
            product.isEnabled = hasProductEnabled;
            this.model.set(type, product);
        }
    },
    updateSeats: function(type, priceData) {
        var seats = this.model.get(type) || {};

        if (Object.keys(seats).length > 0) {
            seats.priceData = priceData;
            this.model.set(type, seats);
        }
    },
    updateMembership: function(data) {
        this.model.set('membership', data);
    },
    updatePrimeUserBlocked: function(isPerksUsageExceeded, primeName) {
        this.model.set({
            isPrimeUserBlocked: isPerksUsageExceeded,
            primeName: primeName,
        });
    },
    updateState: function() {
        this.model.update();
    },
    suscribeInsurancesWidget: function(widgetId) {
        this.model.set('insurances', widgetId);
    },

    subscribeFlexWidget: function(widgetId) {
        this.model.set('flex', widgetId);
    },
    getPriceWithoutDiscountSelected: function() {
        const flightSelectionData = Odigeo.Utils.parseJson(Odigeo.Session.get('flightSelectionData'));
        return Odigeo._.get(flightSelectionData, 'data.priceWithoutDiscountSelected', false);
    },
    shouldShowPrimeUserBlockedNag: function() {
        return (this.model.get('isPrimeUserBlocked')
            && this.options.tests.isPrimeEnabled
            && this.options.tests.isMembershipDualPriceDisplay
            && this.noNagHasBeenShown());
    },
    getHotelReminderTracking: function(isPrime) {
        const reason = Odigeo.Session.get('reasonIntermediate');
        const primeTracking = isPrime ? '_prime' : '';
        return {
            trackingLoad: `nag_hotel_upsell_appearances_${reason}${primeTracking}`,
            trackingAdd: `nag_hotel_upsell_add${primeTracking}`,
            trackingContinue: `nag_hotel_upsell_continue${primeTracking}`,
        };
    },
    getHotelReminderIcon(isPrime) {
        const {brand} = Odigeo.SessionScope;
        const hotelImage = isPrime ? 'Hotel_Prime.png' : 'Hotel_Non-prime.png';
        return Odigeo.Utils.getImageFromCDN(`onefront/bybrand/${brand}/${hotelImage}`);
    },
    showHotelsReminderNag: function() {
        Odigeo.Session.set('ipHotelReminderNagShown', true);
        const nagContainer = NAG_CONTAINERS.CONTAINER_TEMPLATE_HOTEL;
        const {tests, nagTranslations} = this.options;
        const priceWithoutDiscountSelected = this.getPriceWithoutDiscountSelected();
        const isPrime = tests.isPrimeEnabled && !priceWithoutDiscountSelected;
        const tracking = this.getHotelReminderTracking(isPrime);
        const icon = this.getHotelReminderIcon(isPrime);
        const translations = {...nagTranslations.hotelsReminder, icon};

        this.showNag(
            translations,
            tracking,
            Odigeo._.bind(function() {
                Odigeo.trigger(this.id + ':requestXsellAccommodationResults');
            }, this),
            null,
            nagContainer,
            {isPrime}
        );
        trackNag('HOTELS_REMINDER');
        return true;
    },
    getNagsList: function(variation, isOpenedSeatmapOnContinuance) {
        const primeUserBlockedNag = {
            shouldShow: this.shouldShowPrimeUserBlockedNag,
            show: this.showPrimeUserBlockedNag,
        };
        const cabinBagsNag = {
            shouldShow: this.shouldShowPriorityBoardingNag,
            show: this.showPriorityBoardingNag,
        };
        const checkedBagsNag = {
            shouldShow: this.shouldShowBaggageContinueNag,
            show: this.showContinueBaggageNag,
        };
        const seatsNag = {
            shouldShow: isOpenedSeatmapOnContinuance ? () => false : this.shouldShowSeatsNag,
            show: this.showContinueSeatsNags,
        };
        const nagsLogicVariations = {
            [NAGS_LOGIC_VARIATIONS.CABIN_FIRST]: [primeUserBlockedNag, cabinBagsNag, checkedBagsNag, seatsNag],
            [NAGS_LOGIC_VARIATIONS.CHECKED_FIRST]: [primeUserBlockedNag, checkedBagsNag, cabinBagsNag, seatsNag],
            [NAGS_LOGIC_VARIATIONS.CHECKED_ONLY]: [checkedBagsNag],
            [NAGS_LOGIC_VARIATIONS.NO_NAGS]: [],
        };

        return nagsLogicVariations[variation];
    },

    shootNags: function(isOpenedSeatmapOnContinuance) {
        this.updateBaggageNagAvailability();
        const nagsList = this.getNagsList(this.getActiveNagsLogicVariation(), isOpenedSeatmapOnContinuance);
        const nagToShow = nagsList.find((nag) => Odigeo._.bind(nag.shouldShow, this)()) || false;
        if (nagToShow) {
            Odigeo._.bind(nagToShow.show, this)();
            return true;
        }
        return false;
    },

    isNewCabinBagsNagLogicActive: function() {
        return Odigeo.AB.isCabinBagsNagMobile || Odigeo.AB.isCabinBagsNagCompactDesktop || this.isAnyNagsLogicVariationActive();
    },

    isAnyNagsLogicVariationActive: function() {
        return Odigeo.AB.nagsLogicVariationsDesktop > 1 || Odigeo.AB.nagsLogicVariationsMobile > 1;
    },
    getActiveNagsLogicVariation: function() {
        if (!this.isAnyNagsLogicVariationActive()) {
            return 1;
        } else {
            return Odigeo.AB.nagsLogicVariationsDesktop > 1 ? Odigeo.AB.nagsLogicVariationsDesktop : Odigeo.AB.nagsLogicVariationsMobile;
        }
    },

    showContinueBaggageNag: function() {
        if (this.shouldShowSmartNagBaggage()) {
            return this.showSmartNagBaggage();
        }

        if (this.shouldShowEvenUpNag()) {
            return this.showEvenUpBaggageNag();
        }

        return this.showDefaultBaggageContinueNag();
    },
    saveNagsStateToSession: function() {
        Odigeo.Session.set('nagsState', JSON.stringify(this.model.getSessionFormat()));
    },
    getAllBaggageSelectionDTOs: function(travellersNumber) {
        const allBaggageSelection = [];
        for (let i = 0; i <= travellersNumber -1; i++) {
            const baggagesSelectedInfo = this.getBaggagePassengerComposedRowsInfo(i);

            allBaggageSelection.push( Odigeo._.map(baggagesSelectedInfo, function(rowSelectedInfo) {
                let selected = rowSelectedInfo.selected;
                let descriptor = {};
                let descriptorIncluded = {};

                if (selected) {
                    const isSelectable = selected.get('isSelectableBaggage');
                    const isIncluded = selected.get('isIncludedBaggage');

                    selected = selected.getDescriptor();

                    if (isSelectable) {
                        descriptor = selected;
                    } else if (isIncluded) {
                        descriptorIncluded = selected;
                    }
                } else {
                    descriptor = {pieces: 0, kilos: 0, price: 0};
                }

                return {
                    selectedBaggageDescriptor: [
                        {
                            baggageDescriptor: descriptor,
                            price: descriptor.price,
                        },
                    ],
                    baggageDescriptorIncludedInPrice: descriptorIncluded,
                    segmentTypeIndexDTO: rowSelectedInfo.rowDescriptor.get('idRow'),
                };
            }, this));
        }
        return allBaggageSelection;
    },
    exposedMethods: {
        updateMembership: 'updateMembership',
        getAllBaggageSelectionDTOs: 'getAllBaggageSelectionDTOs',
        updatePrimeUserBlocked: 'updatePrimeUserBlocked',
        checkIfFlexNagShouldBeShown: 'checkIfFlexNagShouldBeShown',
        subscribeFlexWidget: 'subscribeFlexWidget',
        suscribeInsurancesWidget: 'suscribeInsurancesWidget',
        checkNoInsuranceSelection: 'noInsuranceSelected',
        onDontWantInsuranceChecked: 'removedInsuranceSelected',
        disableInsurancesNoSelectionNag: 'model.disableInsurancesNoSelectionNag',
        subscribeWidget: 'subscribeWidget',
        showRemoveSeatsNags: 'showRemoveSeatsNags',
        showNoSeatsSelectedNags: 'showNoSeatsSelectedNags',
        notifyNagProductEnabled: 'notifyNagProductEnabled',
        updateSeats: 'updateSeats',
        showHotelsReminderNag: 'showHotelsReminderNag',
        shootNags: 'shootNags',
        seatsSelectionInfo: 'seatsSelectionInfo',
        checkNoInsuranceSelectionIfRejected: 'checkNoInsuranceSelectionIfRejected',
        updateState: 'updateState',
        saveNagsStateToSession: 'saveNagsStateToSession',
        showBasicServiceOptionEvoNag: 'showBasicServiceOptionEvoNag',
        setServiceOptionsEvoNagAlreadyShown: 'setServiceOptionsEvoNagAlreadyShown',
    },

    showNag: function(translations, tracking, actionBtnFunction, ignoreBtnFunction, container, data,
        shouldRebindContinueBtnAfterActionBtnPressed, nagOptions = {}) {
        container = container || NAG_CONTAINERS.CONTAINER_TEMPLATE;
        const nagTemplate = Odigeo._.template(this.view.$el.find(container).html(), Odigeo.Utils.getTmplSettings());
        const trackingPage = tracking.page || Odigeo.History.getPageNameFromFragment();

        this.view.$el.append(nagTemplate({
            translations: translations,
            data: data,
        }));

        const nagLightbox = new Odigeo.UIElements.Lightbox(
            this.view.$el.find('#nag_container'), {
                closeOnOuterClick: false,
                focusClass: '.nag_btn_ignore',
                ...nagOptions,
            });

        this.bindNagButton(nagLightbox, '.nag_btn_action', {action: tracking.trackingAdd, page: trackingPage}, actionBtnFunction,
            shouldRebindContinueBtnAfterActionBtnPressed);
        this.bindNagButton(nagLightbox, '.nag_btn_ignore', {action: tracking.trackingContinue, page: trackingPage},
            ignoreBtnFunction, false);

        nagLightbox.toggle(true);
        trackingUtils.trackEvent('nags', tracking.trackingLoad, trackingPage, true);
    },

    closeNag: function() {
        this.view.$el.find('#nag_container').removeClass('open');
    },

    bindNagButton: function(nagLightbox, btnId, tracking, action, triggerContinueButtonBindings) {
        nagLightbox.$container.on(Odigeo.Events.tap, btnId, Odigeo._.bind(function(event) {
            event.preventDefault();
            event.stopPropagation();
            trackingUtils.trackEvent('nags', tracking.action, tracking.page);
            nagLightbox.remove();
            if (Odigeo._.isFunction(action)) {
                action(event);
            }
            trackClickEvent(event);

            if (triggerContinueButtonBindings) {
                this.enableContinueButton();
            }
        }, this));
    },

    showSmartNagBaggage: function() {
        this.setBaggageContinueNagAlreadyShown();
        this.setBaggageExtendNagAlreadyShown();
        Odigeo.trigger('smart-nag-baggage:showSmartNagBaggage');
    },
    showPriorityBoardingNag: function() {
        if (this.isNewCabinBagsNagLogicActive()) {
            this.setCabinBagsContinueNagAlreadyShown();
        } else {
            this.setBaggageContinueNagAlreadyShown();
            this.setBaggageExtendNagAlreadyShown();
        }

        Odigeo.trigger('boarding-options:showPriorityBoardingNag');
    },
    setEvenUpNagTranslations: function(translations) {
        var bagData = this.getFirstSelectableBaggageData();
        var price = Odigeo.Utils.formatCurrency(bagData.price, Odigeo._.extend({}, Odigeo.Utils.Currency, {
            decimalPlaces: 2,
        }));
        return Odigeo._.extend(translations, {
            subtitle: bagData.kilos > 0 ?
                Odigeo.Utils.pluralizeAll(
                    translations.subtitleWithKilos,
                    bagData.piecesToShow,
                    bagData.kilos,
                    price
                ) :
                Odigeo.Utils.pluralizeAll(
                    translations.subtitleWithoutKilos,
                    bagData.piecesToShow,
                    price
                ),
        });
    },
    showEvenUpBaggageNag: function() {
        var translations = this.setEvenUpNagTranslations(this.options.nagTranslations.baggages.evenUpBaggage);
        this.setBaggageContinueNagAlreadyShown();
        this.setBaggageExtendNagAlreadyShown();
        this.showNag(
            translations,
            {
                trackingLoad: 'nag_baggage_xfaringextend_appearances',
                trackingAdd: 'nag_baggage_xfaringextend_add',
                trackingContinue: 'nag_baggage_xfaringextend_continue',
            },
            Odigeo._.bind(this.evenUpBaggageSelection, this),
            Odigeo._.bind(this.proceedToPayment, this)
        );
        trackNag('BAGGAGE_XFARING_EXTEND');
    },

    continuePrimeUserBlockedNag: function() {
        Odigeo.Session.set('isPrimeBlocked', this.model.get('isPrimeUserBlocked'));
        this.proceedToPayment();
    },

    closePrimeUserBlockedNag: function() {
        this.closeNag();
        this.setPrimeUserBlockedNagToShownAgain();
    },

    showPrimeUserBlockedNag: function() {
        this.setPrimeUserBlockedNagAlreadyShown();
        var primeName = this.model.get('primeName');
        var translations = {
            title: Odigeo.Utils.replaceCmsKeyArgs(this.options.nagTranslations.prime.userBlocked.title, primeName),
            subtitle: this.options.nagTranslations.prime.userBlocked.subtitle,
            button1: this.options.nagTranslations.prime.userBlocked.button1,
            button2: this.options.nagTranslations.prime.userBlocked.button2,
            icon: this.options.nagTranslations.prime.userBlocked.icon,
            usingNotBrandedIcon: true,
        };
        this.showNag(
            translations,
            {
                trackingLoad: 'nag_prime_user_blocked_appearances',
                trackingAdd: 'nag_prime_user_blocked_add',
                trackingContinue: 'nag_prime_user_blocked_continue',
            },
            Odigeo._.bind(this.closePrimeUserBlockedNag, this),
            Odigeo._.bind(this.continuePrimeUserBlockedNag, this),
            null,
            null,
            true
        );
        trackNag('PRIME_USER_BLOCKED');
        return true;
    },

    showBasicServiceOptionEvoNag: function(price) {
        if (!this.model.get('basicServiceOptionEvoNagAlreadyShown')) {
            this.setServiceOptionsEvoNagAlreadyShown();
            var rawGroup = this.options.nagTranslations.serviceOptionsEvo.basicSoSelected;
            var translations = Odigeo._.extend(rawGroup, {
                subtitle: Odigeo.Utils.replaceCmsKeyArgs(rawGroup.subtitle, price),
            });
            var trackingPage = ancillariesTracking.getPageToTrack();
            this.showNag(
                translations,
                {
                    page: trackingPage,
                    trackingLoad: Odigeo._.get(ancillariesTrackingSO.getTrackData('nag.reject.appears', 'B'), 'label'),
                    trackingAdd: Odigeo._.get(ancillariesTrackingSO.getTrackData('nag.reject.accept', 'B'), 'label'),
                    trackingContinue: Odigeo._.get(ancillariesTrackingSO.getTrackData('nag.reject.reject', 'B'), 'label'),
                },
                Odigeo._.bind(this.addRecommendedSoEvo, this),
                Odigeo._.bind(this.addBasicSoEvo, this),
            );
            trackNag('SO_REJECT');
            return true;
        } else {
            this.addBasicSoEvo();
        }
    },

    addRecommendedSoEvo: function() {
        Odigeo.trigger(this.id + ':addRecommendedSoEvo');
    },

    addBasicSoEvo: function() {
        Odigeo.trigger(this.id + ':addBasicSoEvo');
    },

    setServiceOptionsEvoNagAlreadyShown: function() {
        this.model.set('basicServiceOptionEvoNagAlreadyShown', true);
    },

    execute: function(func) {
        return Odigeo.Utils.executeInternalMethods(this, this.exposedMethods, func, Odigeo._.toArray(arguments).slice(1));
    },

    loginDone: function() {
        this.model.set('isUserLoggedIn', true);
    },

    logoutDone: function() {
        this.model.set('isUserLoggedIn', false);
    },
}))));
